import { useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";

import { Modal } from "react-bootstrap";

import "bootstrap/js/dist/modal.js";

import ModalComponentN7 from "../../components/Modal/ModalComponentN7";
import Loading from "../../components/Loading";
import IGVBrowser from "../../components/igv/IGVBrowser";

export default function SearchN7Table() {
    const params = useParams();
    const location = useLocation();
    const [N7Data, setN7Data] = useState([]);
    const [loading, setLoading] = useState(true);

    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    const fetchN7Records = useCallback(() => {
        let searchAdvanced = false;
        const formData = new FormData();

        if (location?.search) {
            searchAdvanced = true;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.forEach((v, k) => {
                formData.append(`filter[${k}]`, v);
            });
        }

        const urlParamsData = new URLSearchParams(formData);
        const sendParam = searchAdvanced ? urlParamsData : `filter[search]=${params?.name}`;

        api.get(`/search/n7?${sendParam}`)
            .then((response) => {
                const data = response.data;
                setN7Data(data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [params?.name, location]);

    useEffect(() => {
        if (params?.name) {
            fetchN7Records();
        }
    }, [params, fetchN7Records]);

    if (loading) return <Loading />;

    return (
        <div className="container">
            {/* <div className="my-5"></div> */}
            <div className="h5 mb-4">Search : {params?.name}</div>

            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>SNV Data</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                SNV ID
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Chromosome No
                            </th>
                            <th scope="col" className="font-monospace text-end">
                                Position
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {N7Data.length > 0 ? (
                            N7Data.map((item) => {
                                return (
                                    <tr key={item?.id}>
                                        <th scope="row" className="font-monospace">
                                            {item?.snv_id}
                                        </th>
                                        <td className="font-monospace text-end">{item?.chromosome_no}</td>
                                        <td className="font-monospace text-end">{item?.position}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td className="text-center" colSpan={5}>
                                    ไม่พบข้อมูลที่Search
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div className="mt-4"></div>

                {N7Data.length > 0 && <IGVBrowser position={N7Data[0].position} chromosome={N7Data[0].chromosome_no} />}
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="font-monospace">SNV ID : {dataModal?.snv_id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN7 data={dataModal} />
                </Modal.Body>
            </Modal>

            <br />
            <br />
            <br />
        </div>
    );
}
